// var TEL_REGEXP = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
var TEL = /^1[1-9]\d{9}$/;
var PASSWORD = /^[A-Za-z]{1,}[A-Za-z0-9]*$/;
var PRICE = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;

export default {
  // 密码
  password: function(rule, value, callback) {
    if (value.length < 8) {
      callback(new Error("密码不能小于8位！"));
    } else if (!PASSWORD.test(value)) {
      callback(new Error("密码必须是字母开头+数字！"));
    } else {
      callback();
    }
  },
  // 手机
  phone: function(rule, value, callback) {
    if (!TEL.test(value)) {
      callback(new Error("手机号码有误！"));
    } else {
      callback();
    }
  },
  // 添加发票时 开票金额
  invoiceAmount: function(rule, value, callback) {
    if (value < 0) {
      callback(new Error("开票金额不能小于0！"));
    } else {
      callback();
    }
  },
  // 输入单位为分时，最多两位小数
  maxFloatTwo: function(rule, value, callback) {
    if (!PRICE.test(value)) {
      callback(new Error("金额只能输入数字且最多只能有两位小数!"));
    } else if (value < 0) {
      callback(new Error("开票金额不能小于0！"));
    } else if (value.length > 15) {
      callback(new Error("金额过大！"));
    } else {
      callback();
    }
  },
};
